export default {
    name: "Logoff",
    title: "Logoff",
    icon: "mdi-logout-variant",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
        };
    },
};